module.exports = __webpack_public_path__ + "e6ff1c5d13b7786272782029310c3615.ttf";